export const MessageRead = [
	{
		label: 'All',
		value: -1,
	},
	{
		label: 'Read',
		value: true,
	},
	{
		label: 'Unread',
		value: false,
	},
];

export const MessageArchived = [
	{
		label: 'All',
		value: -1,
	},
	{
		label: 'Archived',
		value: true,
	},
	{
		label: 'Un-archived',
		value: false,
	},
];

export const MessageAttachments = [
	{
		label: 'All',
		value: -1,
	},
	{
		label: 'Has Attachments',
		value: true,
	},
	{
		label: 'No Attachments',
		value: false,
	},
];
